import { fg } from '@atlassian/jira-feature-gating';

export const canMigrateToNewSpotlightPackage = (): boolean => {
	if (!fg('pol-21470-juno-spotlights-migration')) {
		return false;
	}
	return true;
};
